import { saveAs } from "file-saver";
import { FilesApi } from "../api/files/files.api";
import { swalError } from "../component/notification/swal";

// import { notiError } from "../component/notification/notifications";


// export const handleDownloadNoApi = (file: any) => {
//   const blobUrl = URL.createObjectURL(file);
//   const a = document.createElement('a');
//   a.href = blobUrl;
//   a.download = file.name;
//   a.style.display = 'none';
//   document.body.appendChild(a);
//   a.click();
//   document.body.removeChild(a);
// };

// export const handlePrint = async (id: any) => {
//   try {
//     const res = await IntellectualPropertyReportAPI.print(+id);

//     const data = res.data;
//     let fileType;
//     let fileExtension;

//     const contentType = res.headers["content-type"];

//     switch (contentType) {
//       case "application/pdf":
//         fileType = "application/pdf";
//         fileExtension = ".pdf";
//         break;
//       case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
//         fileType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
//         fileExtension = ".docx";
//         break;
//       case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
//         fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
//         fileExtension = ".xlsx";
//         break;
//       default:
//         throw new Error("Unsupported file type");
//     }

//     const blob = new Blob([data], { type: fileType });

//     saveAs(blob, "ข้อมูลทรัพย์สินทางปัญญา ส1");
//   } catch (error) {
//     notiError(("ดาวน์โหลดไฟล์ไม่สำเร็จ"), "", null, null);
//   }
// };


// export const handleExportExcel = async (dateStart: string, dateEnd: string, typeId: any, groupId: any, subGroupId: any, statusDocId: any, keyword: string, fileName: string) => {
//   try {
//     const res = await IntellectualPropertyReportAPI.excel(dateStart, dateEnd, typeId, groupId, subGroupId, statusDocId, keyword ? keyword : null);
//     const data = res.data;
//     let fileType;
//     let fileExtension;

//     const contentType = res.headers['content-type'];

//     switch (contentType) {
//       case 'application/pdf':
//         fileType = 'application/pdf';
//         fileExtension = '.pdf';
//         break;
//       case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
//         fileType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
//         fileExtension = '.docx';
//         break;
//       case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
//         fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
//         fileExtension = '.xlsx';
//         break;
//       default:
//         throw new Error('Unsupported file type');
//     }

//     const blob = new Blob([data], { type: fileType });

//     saveAs(blob, fileName);
//   } catch (error) {
//     notiError(("ดาวน์โหลดไฟล์ไม่สำเร็จ"), "", null, null);
//   }
// };


// export const handleExportExcelWithDateEnd = async (dateEnd: any, fileName: string) => {
//   try {
//     const res = await IntellectualPropertyReportAPI.excelSum(dateEnd);
//     const data = res.data;
//     let fileType;
//     let fileExtension;

//     const contentType = res.headers['content-type'];

//     switch (contentType) {
//       case 'application/pdf':
//         fileType = 'application/pdf';
//         fileExtension = '.pdf';
//         break;
//       case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
//         fileType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
//         fileExtension = '.docx';
//         break;
//       case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
//         fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
//         fileExtension = '.xlsx';
//         break;
//       default:
//         throw new Error('Unsupported file type');
//     }

//     const blob = new Blob([data], { type: fileType });

//     const fileToSave = fileName.endsWith(fileExtension)
//       ? fileName
//       : fileName + fileExtension;

//     saveAs(blob, fileToSave);
//   } catch (error) {
//     notiError(("ดาวน์โหลดไฟล์ไม่สำเร็จ"), "", null, null);
//   }
// };


export const handleDownload = async (fileAttachmentId: any, fileName: any) => {
  try {
    const res = await FilesApi.getFile(fileAttachmentId);
    const data = res.data;
    let fileType;
    let fileExtension;

    const contentType = res.headers["content-type"];

    switch (contentType) {
      case "application/pdf":
        fileType = "application/pdf";
        fileExtension = ".pdf";
        break;
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        fileType =
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        fileExtension = ".docx";
        break;
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        fileExtension = ".xlsx";
        break;
      default:
        throw new Error("Unsupported file type");
    }

    const blob = new Blob([data], { type: fileType });

    const fileToSave = fileName.endsWith(fileExtension)
      ? fileName
      : fileName + fileExtension;

    saveAs(blob, fileToSave);
  } catch (error) {
    swalError(("ดาวน์โหลดไฟล์ไม่สำเร็จ"));

  }
};


// export const handleDownloadAndPreview = async (fileAttachmentId: any) => {
//   try {
//     const res = await FileAttachmentAPI.download(fileAttachmentId);
//     const data = res.data;
//     const blob = new Blob([data], { type: "application/pdf" });

//     window.open(URL.createObjectURL(blob), "_blank");
//   } catch (error) {

//   }
// };

